/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type billing_FamilyGroupMemberRequest = {
    can_make_payments?: boolean;
    /**
     * Permissions
     */
    can_view_invoices?: boolean;
    /**
     * ContactID of the member
     */
    contact_id: string;
    /**
     * MemberRole (PARENT, GUARDIAN, OTHER)
     */
    member_role?: billing_FamilyGroupMemberRequest.member_role;
    /**
     * PaymentPercentage for split billing
     */
    payment_percentage?: number;
    /**
     * ReceivesSeparateInvoice flag
     */
    receives_separate_invoice?: boolean;
};
export namespace billing_FamilyGroupMemberRequest {
    /**
     * MemberRole (PARENT, GUARDIAN, OTHER)
     */
    export enum member_role {
        PARENT = 'PARENT',
        GUARDIAN = 'GUARDIAN',
        OTHER = 'OTHER',
    }
}

